// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"526afc12","239":"9ce14f58","732":"ebd58816"}[chunkId] + ".chunk.js";
};